// src/routes/AppRoutes.tsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import AppLayout from "../components/layout/AppLayout";
import ProtectedRoute from "../components/ui/ProtectedRoute";

import LoginPage from "../pages/login/LoginPage";
import DashboardPage from "../pages/dashboard/DashboardPage";
import RetirosPage from "../pages/retiros/RetirosPage";
import WalletsPage from "../pages/wallets/WalletsPage";
import ComisionesPage from "../pages/comisiones/ComisionesPage";
import ConfiguracionPage from "../pages/configuracion/ConfiguracionPage";
import DisputasPage from "../pages/disputas/DisputasPage";
import DisputaDetallePage from "../pages/disputas/DisputaDetallePage";
import MvzVerificacionPage from "../pages/mvz/MvzVerificacionPage";
import SubastasPage from "../pages/subastas/SubastasPage";
import UsuariosSubastaPage from "../pages/usuarios/UsuariosSubastaPage";
import SubastaOBSPage from "../pages/obs/SubastaOBSPage";
import VerificacionesPage from "../pages/verificaciones/VerificacionesPage";
import CorralPricingAdminPage from "../pages/corrales/CorralPricingAdminPage";
import CorralCouponsAdminPage from "../pages/corrales/CorralCouponsAdminPage";

// ── Rutas completamente públicas — sin auth, sin layout ──────────────────
// Se interceptan ANTES de que cualquier ProtectedRoute o Navigate se ejecute.
// Esto garantiza que /subasta-obs nunca sea tapada por el LoginPage.
const PUBLIC_PATHS = ["/subasta-obs"];

export default function AppRoutes() {
  const location = useLocation();

  // Retorno temprano para rutas públicas: sin Routes, sin ProtectedRoute
  if (PUBLIC_PATHS.includes(location.pathname)) {
    return <SubastaOBSPage />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="retiros" element={<RetirosPage />} />
        <Route path="disputas" element={<DisputasPage />} />
        <Route path="disputas/:id" element={<DisputaDetallePage />} />
        <Route path="wallets" element={<WalletsPage />} />
        <Route path="comisiones" element={<ComisionesPage />} />
        <Route path="configuracion" element={<ConfiguracionPage />} />
        <Route path="mvz-verificacion" element={<MvzVerificacionPage />} />
        <Route path="subastas" element={<SubastasPage />} />
        <Route path="usuarios-subasta" element={<UsuariosSubastaPage />} />
        <Route path="verificaciones" element={<VerificacionesPage />} />
        <Route path="corrales-pricing" element={<CorralPricingAdminPage />} />
        <Route path="corrales-cupones" element={<CorralCouponsAdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
